import {
  RunSystemArchivingDto,
  RunSystemDto
} from 'src/store/runsystems/runsystem';
import { ArrayUtils } from 'src/utils/array';
import { RunSystemAction, RunSystemTypes } from './runsystems.actions';

export type RunSystemsState = Readonly<{
  runSystems: RunSystemDto[];
  errors: any;
  runSystemArchiving: RunSystemArchivingDto[];
}>;

const initialState: RunSystemsState = {
  runSystems: [],
  errors: null,
  runSystemArchiving: []
};

const runSystemsReducer = (
  state: RunSystemsState = initialState,
  action: RunSystemAction
) => {
  switch (action.type) {
    case RunSystemTypes.FetchAll:
      return { ...state, runSystems: action.runSystems };
    case RunSystemTypes.Add:
      return { ...state, runSystems: [...state.runSystems, action.runSystem] };
    case RunSystemTypes.Update:
      return {
        ...state,
        runSystems: ArrayUtils.updateListById(
          state.runSystems,
          action.runSystem
        )
      };
    case RunSystemTypes.Delete:
      return {
        ...state,
        runSystem: null,
        runSystems: ArrayUtils.deleteFromListById(
          state.runSystems,
          action.runSystem
        )
      };
    case RunSystemTypes.Archiving:
      return { ...state, runSystemArchiving: action.runSystemArchiving };
    case RunSystemTypes.Failure:
      return { ...state, errors: action.errors };
    default:
      return state;
  }
};

export default runSystemsReducer;
